import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { TranslateModule } from '@ngx-translate/core';

import { LanguageService } from '@shared/services';

@Component({
  selector: 'rp-home-fast-performance-schema',
  standalone: true,
  templateUrl: './fast-performance-schema.component.html',
  styleUrl: './../schema.base.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule],
})
export class FastPerformanceSchemaComponent {
  private readonly languageService = inject(LanguageService);

  // eslint-disable-next-line @typescript-eslint/member-ordering
  readonly selectedLanguage = toSignal<string>(this.languageService.selectedLanguage$);
  // eslint-disable-next-line @typescript-eslint/member-ordering
  readonly isSelectedRu = computed(() => this.selectedLanguage() === 'RU');
}
